const initialState = {
  routes: {},
};

export default function routesReducer(state = initialState) {
  return state;
}
